/**
 * Created by Armaldio on 11/01/2018.
 */
import AddonDetails from './AddonDetails'

export default AddonDetails;



// WEBPACK FOOTER //
// ./src/components/AddonDetails/index.js